import { LocaleId } from '@domgen/dgx-fe-i18n';
import { TranslationDictionaryMapping } from '@domgen/dgx-fe-i18n/lib/models/translation-dictionary/translation-dictionary-mapping.type';
import { FeaturePersonalDetailsTranslationDictionary } from '../models/i18n/feature-personal-details-dictionary.interface';
import { enGbTranslation } from './translation.en-gb.constant';
import { enIeTranslation } from './translation.en-ie.constant';
import { enUsTranslation } from './translation.en-us.constant';

export const translation: TranslationDictionaryMapping<FeaturePersonalDetailsTranslationDictionary> =
  {
    [LocaleId.English_GreatBritain]: enGbTranslation,
    [LocaleId.English_Ireland]: enIeTranslation,
    [LocaleId.English_US]: enUsTranslation,
  };
